import { observable, action, toJS, computed, makeObservable } from 'mobx'
import api from '../service/api'
import NotificationStore from "./notification.store"
import React from 'react'
// import UserStore from "./user.store";
const notification = NotificationStore

class ExamStore {
    exams
    selectedExam

    constructor () {
        this.exams = []
        this.selectedExam = {}
        this.api = api
        makeObservable( this, {
            exams: observable,
            selectedExam: observable,
            getExam: computed,
            getExams: computed,
            createExam: action,
            updateExam: action,
            setExams: action,
            setSelectedExam: action,
            fetchExam: action,
            fetchExams: action
        } )
    }

    get getExam () {
        return toJS( this.selectedExam )
    }

    get getExams () {
        return toJS( this.exams )
    }

    setExams ( exams ) {
        this.exams = exams
    }

    setSelectedExam ( exam ) {
        this.selectedExam = exam
    }

    async createExam ( payload ) {
        try {
            await this.api.createExam( payload )
        } catch ( err ) {
            console.log( err )
            notification.setNotification( true, err.response && err.response.data ? err.response.data : "Something went wrong!" )
        }
    }

    async fetchExams () {
        try {
            const res = await this.api.getAllExams()
            if ( res.success === true || res.data.data ) {
                this.setExams( res.data.data )
                return true
            } else
                return false
        } catch ( err ) {
            console.log( err )
            notification.setNotification( true, err.response && err.response.data ? err.response.data : "Something went wrong!" )
        }
    }

    async fetchExamsByDept ( deptCode ) {
        try {
            const res = await api.fetchExamsByDept( deptCode )
            if ( res.success === true || res.data.exams ) {
                this.setExams( res.data.exams )
                return true
            } else
                return false
        } catch ( err ) {
            console.log( err )
            notification.setNotification( true, err.response && err.response.data ? err.response.data : "Something went wrong!" )
        }
    }

    async fetchExamsByInstitute ( institute ) {
        try {
            const res = await api.fetchExamsByInstitute( institute )
            if ( res.data.success === true || res.data.exams ) {
                console.log( res.data )
                this.setExams( res.data.exams )
                return true
            } else {
                console.log( res.data )

                return false
            }
        } catch ( err ) {
            console.log( err )
            notification.setNotification( true, err.response && err.response.data ? err.response.data : "Something went wrong!" )
        }
    }


    async updateExam ( id, payload ) {
        try {
            const res = await this.api.updateExam( id, payload )
            if ( res.status === 200 ) {
                notification.setNotification( true, "Exam updated" )
            }
            await this.fetchExam( id )

        } catch ( err ) {
            console.log( err )
            notification.setNotification( true, err.response && err.response.data ? err.response.data : "Something went wrong!" )
        }
    }

    async fetchExam ( id ) {
        try {
            const res = await this.api.getExam( id )
            this.setSelectedExam( res.data )
            return { success: true }
        } catch ( err ) {
            console.log( err )
            notification.setNotification( true, err.response && err.response.data ? err.response.data : "Something went wrong!" )
            return { success: false, code: err?.response?.status }
        }
    }
}


const ExamStoreInstance = new ExamStore()

export default ExamStoreInstance

const ExamStoreContext = React.createContext()

export const ExamStoreProvider = ( { children, store } ) => {
    return (
        <ExamStoreContext.Provider value={store}>{children}</ExamStoreContext.Provider>
    )
}

/* Hook to use store in any functional component */
export const useExamStore = () => React.useContext( ExamStoreContext )